import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc';
import {strEncode,strDecode} from '../../encrpt';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"; // Ensure you install react-datepicker
import {API_BASE_URL} from "../../apiConfig.jsx";
import '../Raportee/datatable.css';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


function DataEntryData() {

	const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");

		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);
	const [data, setData] = useState([]);
	const [composant_data, setComposantData] = useState([]);
	const [error, setError] = useState(null);
	const [subcompname, setModalheading] = useState(null);
	const [modalData, setModalData] = useState([]);
	const [formData, setFormData] = useState(modalData.map(row => ({ ...row, dateValue: row.date || null })));
	const [headerscols, setHeaders] = useState([]);
	const [mergedData, setMergedData] = useState({});
    const [editableRowId, setEditableRowId] = useState(null); // Track editable row
  const [updatedData, setUpdatedData] = useState(data); // Store editable data
  const [openPDO, setOpenPDO] = useState(null);
  const [openComponent, setOpenComponent] = useState(null);

  // Toggle PDO-level visibility
  const togglePDO = (pdoName) => {
    setOpenPDO(openPDO === pdoName ? null : pdoName);
    setOpenComponent(null); // Reset component selection when switching PDO
  };

  // Toggle Component-level visibility
  const toggleComponent = (componentName) => {
    setOpenComponent(openComponent === componentName ? null : componentName);
  };
  // Merge header rows above formatted columns dynamically
    // const mergeData = [...headerRows, ...formData]; // Ensuring headers appear first
	
	
     const maxLength = headerscols.length;
	 const filteredHeaders = headerscols.slice(0, maxLength - 1);
     const customStyles = {
		headCells: {
		  style: {
			color:"white",
			background:"black",
			whiteSpace: "normal",
			wordBreak: "break-word",
			overflowWrap: "break-word",
			textAlign: "center",
			wrap :true
		  },
		},
	  }; 

 	    const formattedColumns = Object.keys(formData[0] || {}).map((col) => {
		const displayName = col.includes("col_") ? headerscols[maxLength-1][col] || col : col.replace(/_/g, " ");
		return {
		  name: displayName,
		  selector: row => row[col],
		  sortable: true,
		  wrap: true,
		  cell: (row, index)=>		  
			editableRowId === row.id ? (
				(displayName === "col_1" || displayName.includes("Date")) ?
				<div style={{ width: "100px" }}>
				  <DatePicker
					selected={row[col] && !isNaN(Date.parse(row[col])) ? new Date(row[col]) : new Date()}
					onChange={(date) => handleInputChange(row.id, col, date)}
					dateFormat="yyyy-MM-dd"
					className="input-box"
					placeholderText="Select Date"
					style={{ width: "100px" }}
				  />
				</div> :
                (displayName.includes("Réalisation") ||  displayName.includes("Revue")) ?
               	<input
					type="text"
					className="input-box"
					value={row[col] || ""}
					onChange={(e) => handleInputChange(row.id, col, e.target.value)}
				/>
				 : (displayName.includes("Commentaires")) ?
				 <textarea
				  className="input-box"
				  value={row[col] || ""}
				  onChange={(e) => handleInputChange(row.id, col, e.target.value)}
			  /> :  row[col]
			) : (
				<span onClick={() => handleRowClick(row)}>{row[col]}</span>
			),
			subHeader: headerscols[maxLength - 2]?.[col] || "", // Fetch sub-header from the previous row dynamically
		};
	  });
	  const formatted_Columns = formattedColumns.filter((_, index) => index !== 4 && index !== 0);
	 /* const dataTableColumns = formatted_Columns.map((col) => ({
		...col,
		name: (
		  <div>
			<div style={{background:"green"}}><strong>{col.subHeader}</strong></div>
			<div>{col.name}</div>
		  </div>
		)
	  })); */

	  const dataTableColumns = formatted_Columns.map((col, index, arr) => {
		if (col.name.startsWith("col_") && index > 0) {
			arr[index - 1] = {
			...arr[index - 1],
			colSpan: 2, // Adjust colSpan as needed
		  };
	  
		  // Make the current column blank
		  return {
			...col,
			name: "",
		  };
		}
	  
		return {
		  ...col,
		  name: (
			<div>
			  <div style={{ background: "green" }}>
				<strong>{col.subHeader}</strong>
			  </div>
			  <div>{col.name}</div>
			</div>
		  ),
		};
	  });
	
	  const handleRowClick = (row) => {
		console.log("rowid",row["id"])
		setEditableRowId(prevId => prevId === row["id"] ? null : row["id"]); // Toggle edit mode
	};

	 useEffect(() => {
		axios.post(`${API_BASE_URL}/api/getindicator`, { t: strEncode('component_master')},{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            //console.log("res",res.data)
            setData(res.data);
          }).catch( (error) => { console.log(error); });
        
    }, []);
   
	useEffect(() => {
		if (modalData.length > 0) { // Ensure modalData contains valid entries
			setFormData(modalData.filter(row => Object.values(row).some(value => value !== "" && value !== null && value !== undefined)));
		}
	}, [modalData]);

	const rowDisabledCriteria = row => row.isOutOfStock;
	const rowPreDisabled = row => row.disabled;
	const ExpandedComponent = ({ formData }) => <pre>{JSON.stringify(formData, null, 2)}</pre>;
	

	const handleModalOpen = (id,subcomname) => {
		axios.post(`${API_BASE_URL}/api/getrealizationdata`, { t: strEncode('indicator_master'),indicatorid : strEncode(id)},{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            //console.log("subcomponent",res.data)
			axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('data_collection_planning_cols'),whrc : strEncode("component_id = "+id+"")},{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (colsval) => {	
			//console.log("colsval",colsval.data)
		const mergedModalData = [...colsval.data, ...res.data];
		setMergedData(mergedModalData);
        setHeaders(colsval.data); // Set headers separately if needed
        setModalData(res.data); // Store merged header + modal data
        setModalheading(subcomname);
		})
          }).catch( (error) => { console.log(error); });
	};

	  // Handle input changes
	  const handleInputChange = (rowId, field, value) => {
		setFormData(prevData => {
			const updatedData = prevData.map(row => 
				row.id === rowId ? { ...row, [field]: value instanceof Date ? value.toISOString().slice(0, 10) : value } : row
			);
			const modifiedRow = updatedData.find(row => row.id === rowId); // Get the updated row
			
			setUpdatedData(modifiedRow); // Store the modified row instead of just rowId
			return updatedData;
		});
	};

	    
    // Submit data to backend
   	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!updatedData) {
			alert("No changes detected.");
			return;
		}
	
		try {
			const response = await axios.post(`${API_BASE_URL}/api/realization/update`, { 
				id: updatedData.id, 
				data: updatedData 
			});
			alert("Data Updated successfully!");
		} catch (error) {
			console.error("Error saving data:", error);
		}
		
		setEditableRowId(null); // Reset edit mode after submitting
	};


	const [searchTerm, setSearchTerm] = useState("");
     
	const closeModal = () => {
     setFormData([]);
	}

    const filteredData = formData.filter(item =>
		(searchTerm || "").toLowerCase().includes((item.name || "").toLowerCase()) ||
		(searchTerm || "").toLowerCase().includes((item.email || "").toLowerCase())
	);

		const exportExcel_1 = () => {
		//console.log("filteredData",)
		if (!filteredData.length) {
			alert("No data available to export.");
			return;
		}
		
		const columnNames = formatted_Columns.map(item => item.name); 		
		const columnHeaders = Object.keys(formData[0]).filter((_, index) => index !== 3 && index !== 0);
		const excelData = formData.map(row => columnHeaders.map(header => row[header] !== undefined ? row[header] : ""));
	    // Create worksheet and workbook
		const worksheet = XLSX.utils.aoa_to_sheet([columnNames, ...excelData]);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
	
		// Export to Excel file
		XLSX.writeFile(workbook, "exported_data.xlsx");
	};

	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/dashboard/blank">Raportee</Link></li>
				<li className="breadcrumb-item active">Liste des données</li>
			</ol>
			<h1 className="page-header">Liste des données</h1>
			<Panel>
				<PanelHeader>Liste des composants et sous-composants à afficher et à modifier</PanelHeader>
				<PanelBody>
				<ul className="nav nav-pills mb-2">
      {data.map((item) => (
        <li className="nav-item" key={item.pdo} style={{width:"100%"}}>
          <a
            href="#"
            className={`nav-link ${openPDO === item.pdo ? "active" : ""}`}
            onClick={(e) => {
				e.preventDefault();  togglePDO(item.pdo)}}
          >
            {item.pdo}
          </a>

          {/* Tab Content Directly Below - Toggle Structure */}
          {openPDO === item.pdo && (
            <div className="tab-content p-3 rounded-top panel rounded-0 m-0">
              {item.component.map((comp) => (
                <div key={comp.component}>
                  <ul className="nav nav-pills mb-2">
                    <li className="nav-item" style={{width:"100%"}}>
                      <a
                        href="#"
                        className={`nav-link ${openComponent === comp.component ? "active" : ""}`}
                        onClick={(e) => {
							e.preventDefault();  toggleComponent(comp.component)}}
                      >
                        {comp.component}
                      </a>
                    </li> 
                  </ul>

                  {/* Nested Tab Content for Components - Toggle Structure */}
                  {openComponent === comp.component && (
                    <div className="tab-content p-3 rounded-top panel rounded-0 m-0">
                      {comp.subcomponent.map((subcomp) => (
                        <ul className="nav nav-pills mb-2" key={subcomp.id}>
                          <li className="nav-item" style={{width:"100%"}}>
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#modalPosBooking"
                              className="pos-table-booking"
                              onClick={(e) => {
								e.preventDefault(); 
								 handleModalOpen(subcomp.id, subcomp.subcomponents)}}
                            >
                              {subcomp.subcomponents}
                            </a>
                          </li>
                        </ul>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </li>
      ))}
    </ul>	
				</PanelBody>
			</Panel>
			<div className="modal modal-pos fade" id="modalPosBooking">
				<div className="modal-dialog modal-lg" style={{maxWidth:"95%"}}>
					<div className="modal-content border-0">
						<div>
							<div className="p-0">

							<form onSubmit={handleSubmit}>
							<div className="modal-body">
									<div className="d-flex align-items-center mb-3">
										<h4 className="modal-title d-flex align-items-center"><i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i> {subcompname}</h4>
										<a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
									</div>
									<div className="row">
									<div className="table-responsive">
									<div>          
          
            <button type="button" className="btn btn-success" onClick={exportExcel_1} style={{ margin: "5px" }}>Export Excel</button>
			<DataTable 
						columns={dataTableColumns} 
						data={formData} 
						pagination 
						defaultSortFieldId="id" // Ensures sorting is based on row ID initially
                        defaultSortAsc={true} // Set to false for descending order
						customStyles={customStyles}
						className="datatable-header"
						onRowClicked={handleRowClick}
						/>
        </div>
								
				
							</div>
									</div>
								</div>
								<div className="modal-footer">									
								{editableRowId > 0 ? <button type="submit" className="btn btn-success w-100px">Update</button> : "" }
								</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DataEntryData;